module.exports = __webpack_public_path__ + "img/qr-app-de.29bbca7.svg";